import { __assign } from 'tslib';
import React__default from 'react';
import * as ReactDOM from 'react-dom';
import { toast, Slide } from 'react-toastify';
import { ToastContainer } from '../ToastContainer/ToastContainer.component.js';
import { Toast } from './Toast.component.js';
import { defaultProps } from './Toast.types.js';
import styles from './Toast.module.scss.js';

var isdDefaultContainerRendered = !!document.getElementById(defaultProps.containerId);
if (!isdDefaultContainerRendered) {
    if (!ReactDOM.render) {
        console.error("ReactDOM v" + ReactDOM.version + "  does not support default container creation,\n            please add it manually to the root component\n            import { isdDefaultContainerRendered, ToastContainer } from 'spoton-lib';\n\n            function App() {\n                return (\n                    <>\n                        {!isdDefaultContainerRendered && <ToastContainer />}\n                        ...rest project\n                    </>\n                )\n            }\n            ");
    }
    else {
        var newDiv = document.createElement('div');
        document.body.append(newDiv);
        ReactDOM.render(React__default.createElement(ToastContainer, null), newDiv);
    }
}
function showToast(props) {
    var toastProps = __assign(__assign({}, defaultProps), props);
    var position = toastProps.position, autoClose = toastProps.autoClose, limit = toastProps.limit, containerId = toastProps.containerId;
    toast(function (contentProps) { return (React__default.createElement(Toast, __assign({}, contentProps, toastProps, { onClose: function () {
            var _a, _b;
            (_a = contentProps.closeToast) === null || _a === void 0 ? void 0 : _a.call(contentProps);
            (_b = toastProps.onClose) === null || _b === void 0 ? void 0 : _b.call(toastProps);
        } }))); }, {
        className: styles.ToastWrapper,
        containerId: containerId,
        position: position,
        autoClose: autoClose,
        closeOnClick: false,
        transition: Slide,
        hideProgressBar: true,
        closeButton: false,
    });
    // clear queue of toasts when using the limit prop
    if (limit) {
        toast.clearWaitingQueue({ containerId: containerId });
    }
}

export { showToast as default, isdDefaultContainerRendered };
